<template>
  <div class="hello row">
    <div id="adminMenu">
        <h3>PEA Admin options</h3>
      <admin-nav></admin-nav>
    </div>
    <div id="adminContent" style="width:100%;">
      <br />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adminArea'
}
</script>

<style scoped>
#adminMenu {
  width: 100%;
  margin-top: -10px;
  background: white;
  z-index: 12;
}
</style>
